var _path, _g, _path2, _g2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotfoundrepodark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 93,
    viewBox: "0 0 160 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.293 16.3882C156.997 16.3882 160 19.3126 160 22.92C160 26.5274 156.997 29.4517 153.293 29.4517H114.97C118.674 29.4517 121.677 32.3761 121.677 35.9835C121.677 39.5909 118.674 42.5152 114.97 42.5152H136.048C139.752 42.5152 142.754 45.4396 142.754 49.047C142.754 52.6543 139.752 55.5787 136.048 55.5787H126.3C121.63 55.5787 117.844 58.5031 117.844 62.1105C117.844 64.5154 119.76 66.6926 123.593 68.6422C127.297 68.6422 130.299 71.5666 130.299 75.1739C130.299 78.7813 127.297 81.7057 123.593 81.7057H44.0719C40.3679 81.7057 37.3653 78.7813 37.3653 75.1739C37.3653 71.5666 40.3679 68.6422 44.0719 68.6422H6.70659C3.00264 68.6422 0 65.7178 0 62.1105C0 58.5031 3.00264 55.5787 6.70659 55.5787H45.0299C48.7339 55.5787 51.7365 52.6543 51.7365 49.047C51.7365 45.4396 48.7339 42.5152 45.0299 42.5152H21.0778C17.3739 42.5152 14.3713 39.5909 14.3713 35.9835C14.3713 32.3761 17.3739 29.4517 21.0778 29.4517H59.4012C55.6973 29.4517 52.6946 26.5274 52.6946 22.92C52.6946 19.3126 55.6973 16.3882 59.4012 16.3882H153.293ZM153.293 42.5152C156.997 42.5152 160 45.4396 160 49.047C160 52.6543 156.997 55.5787 153.293 55.5787C149.589 55.5787 146.587 52.6543 146.587 49.047C146.587 45.4396 149.589 42.5152 153.293 42.5152Z",
    fill: "#2B2E31"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_36677_44881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.1941 18.5674L110.893 70.0301C111.374 71.8079 110.317 73.5857 108.491 74.0535L56.708 87.4338C54.8826 87.9016 53.0572 86.8724 52.5769 85.0946L34.5151 18.661C34.0348 16.8832 35.0916 15.1054 36.9169 14.6376L74.3855 5L96.1941 18.5674Z",
    fill: "#AFB4BA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3857 5L78.2287 19.2224C78.8051 21.1873 81.0148 22.4037 83.0323 21.8423L96.1943 18.5674",
    fill: "#D5DDEA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_36677_44881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.399 33.0735L117.56 85.8461C117.272 87.6239 115.446 88.8403 113.621 88.466L60.973 79.4834C59.1476 79.2027 57.8986 77.4249 58.1869 75.6471L70.3881 7.99713C70.6764 6.21933 72.5018 5.00294 74.3271 5.37722L112.564 11.927L126.399 33.0735Z",
    fill: "#BFC4CA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.469 11.9262L109.875 26.4293C109.491 28.4878 111.028 30.4528 113.142 30.827L126.4 33.0727",
    fill: "#AFB3BE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.6193,
    cy: 42.9955,
    rx: 22.0968,
    ry: 21.5207,
    fill: "#BFC4CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6736 45.8676C67.932 45.8676 68.9967 44.8307 68.9967 43.6051C68.9967 42.3796 67.932 41.3427 66.6736 41.3427C65.4153 41.3427 64.3506 42.3796 64.3506 43.6051C64.3506 44.8307 65.4153 45.8676 66.6736 45.8676Z",
    fill: "#989FB0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4842 45.8676C85.7425 45.8676 86.8072 44.8307 86.8072 43.6051C86.8072 42.3796 85.7425 41.3427 84.4842 41.3427C83.2259 41.3427 82.1611 42.3796 82.1611 43.6051C82.1611 44.9249 83.2259 45.8676 84.4842 45.8676Z",
    fill: "#989FB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5828 36.118L61.4727 38.8053L62.1625 40.0495L67.2726 37.3623L66.5828 36.118Z",
    fill: "#989FB0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1672 36.0825L83.4775 37.3269L88.5883 40.0136L89.2779 38.7692L84.1672 36.0825Z",
    fill: "#989FB0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5784 51.1454C77.0752 51.1454 78.2886 50.2591 78.2886 49.1657C78.2886 48.0724 77.0752 47.186 75.5784 47.186C74.0816 47.186 72.8682 48.0724 72.8682 49.1657C72.8682 50.2591 74.0816 51.1454 75.5784 51.1454Z",
    fill: "#989FB0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.75 71.8375L89.8096 59.2443L92.7762 56.3551L105.706 68.9582L102.75 71.8375Z",
    fill: "#5D6373"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.195 78.1638L99.2718 68.4998C98.4432 67.6928 98.4432 66.3777 99.2718 65.5707C100.1 64.7637 101.451 64.7637 102.279 65.5707L112.202 75.2347C113.031 76.0417 113.031 77.3568 112.202 78.1638C111.373 78.9708 110.023 78.9708 109.195 78.1638Z",
    fill: "#5D6373"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.488 78.7833L95.7215 66.3496C95.4249 66.0607 95.4249 65.5924 95.7215 65.2935L98.9848 62.1154C99.2814 61.8265 99.7622 61.8265 100.069 62.1154L112.836 74.5491C113.132 74.838 113.132 75.3063 112.836 75.6052L109.572 78.7833C109.266 79.0722 108.785 79.0722 108.488 78.7833Z",
    fill: "url(#paint0_linear_36677_44881)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1619 18.6665C61.618 18.6665 50.6416 29.3567 50.6416 42.5476C50.6416 55.7285 61.618 66.4287 75.1517 66.4287C88.6957 66.4287 99.6721 55.7385 99.6721 42.5476C99.6721 29.3567 88.6957 18.6665 75.1619 18.6665ZM75.1619 62.0051C64.2879 62.0051 55.4802 53.2876 55.4802 42.5376C55.4802 31.7877 64.2879 23.0801 75.1619 23.0801C86.036 23.0801 94.8437 31.7976 94.8437 42.5476C94.8437 53.2976 86.0258 62.0051 75.1619 62.0051Z",
    fill: "url(#paint1_linear_36677_44881)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_36677_44881",
    x: 31.3994,
    y: 0.14,
    width: 82.6094,
    height: 88.5465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.86
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.235294 0 0 0 0 0.278431 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36677_44881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36677_44881",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_36677_44881",
    x: 55.1455,
    y: 0.449387,
    width: 74.2529,
    height: 89.2244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.86
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.235294 0 0 0 0 0.278431 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36677_44881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36677_44881",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36677_44881",
    x1: 95.491,
    y1: 70.4512,
    x2: 113.061,
    y2: 70.4512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8892A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36677_44881",
    x1: 50.6191,
    y1: 42.5528,
    x2: 99.681,
    y2: 42.5528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8892A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7686"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfoundrepodark);
export default __webpack_public_path__ + "static/media/notfoundrepodark.f621124a884e4cc9b75e50f5ea71215e.svg";
export { ForwardRef as ReactComponent };